import loadable from 'utils/loadable';

export const ScoreCardTemplates = loadable(() => import('./index'), {
  fallback: null,
});
